var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.61 8.071A7.5 7.5 0 0 1 19.5 11.96l-1.688-1.35a.5.5 0 1 0-.624.78l2.5 2a.5.5 0 0 0 .624 0l2.5-2a.5.5 0 1 0-.624-.78L20.5 11.96A8.5 8.5 0 0 0 4.759 7.546a.5.5 0 1 0 .851.525m.578 5.32L4.5 12.04a7.5 7.5 0 0 0 13.702 4.177.5.5 0 0 1 .826.564A8.5 8.5 0 0 1 3.5 12.04l-1.688 1.35a.5.5 0 1 1-.624-.78l2.5-2a.5.5 0 0 1 .624 0l2.5 2a.5.5 0 1 1-.624.78",
    clipRule: "evenodd"
  })));
});
const SvgReload = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReload);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjYxMDEzIDguMDcxMUM2LjkzMTI5IDUuOTI3MjggOS4yOTkxOSA0LjUgMTIgNC41QzE2LjEyODcgNC41IDE5LjQ3ODIgNy44MzYwNSAxOS40OTk5IDExLjk1OTZMMTcuODEyNCAxMC42MDk2QzE3LjU5NjcgMTAuNDM3MSAxNy4yODIxIDEwLjQ3MiAxNy4xMDk2IDEwLjY4NzdDMTYuOTM3MSAxMC45MDMzIDE2Ljk3MiAxMS4yMTc5IDE3LjE4NzcgMTEuMzkwNEwxOS42ODc3IDEzLjM5MDRDMTkuODcwMyAxMy41MzY1IDIwLjEyOTggMTMuNTM2NSAyMC4zMTI0IDEzLjM5MDRMMjIuODEyNCAxMS4zOTA0QzIzLjAyOCAxMS4yMTc5IDIzLjA2MyAxMC45MDMzIDIyLjg5MDUgMTAuNjg3N0MyMi43MTc5IDEwLjQ3MiAyMi40MDMzIDEwLjQzNzEgMjIuMTg3NyAxMC42MDk2TDIwLjQ5OTkgMTEuOTU5OEMyMC40NzgzIDcuMjgzODUgMTYuNjgxIDMuNSAxMiAzLjVDOC45Mzc4NiAzLjUgNi4yNTQ0MSA1LjExOTU3IDQuNzU4ODEgNy41NDY0N0M0LjYxMzkzIDcuNzgxNTUgNC42ODcwNyA4LjA4OTU3IDQuOTIyMTUgOC4yMzQ0NUM1LjE1NzI0IDguMzc5MzIgNS40NjUyNiA4LjMwNjE5IDUuNjEwMTMgOC4wNzExWk02LjE4NzY3IDEzLjM5MDRMNC41MDAxMiAxMi4wNDA0QzQuNTIxODcgMTYuMTYzOSA3Ljg3MTM2IDE5LjUgMTIgMTkuNUMxNC41NzczIDE5LjUgMTYuODUxMiAxOC4yMDA0IDE4LjIwMjEgMTYuMjE4NUMxOC4zNTc2IDE1Ljk5MDQgMTguNjY4NyAxNS45MzE1IDE4Ljg5NjggMTYuMDg3QzE5LjEyNSAxNi4yNDI1IDE5LjE4MzkgMTYuNTUzNiAxOS4wMjg0IDE2Ljc4MThDMTcuNDk5MyAxOS4wMjUyIDE0LjkyMTkgMjAuNSAxMiAyMC41QzcuMzE5MDIgMjAuNSAzLjUyMTc4IDE2LjcxNjEgMy41MDAxMSAxMi4wNDAyTDEuODEyMzcgMTMuMzkwNEMxLjU5Njc0IDEzLjU2MjkgMS4yODIwOSAxMy41MjggMS4xMDk1OCAxMy4zMTIzQzAuOTM3MDc5IDEzLjA5NjcgMC45NzIwNCAxMi43ODIxIDEuMTg3NjcgMTIuNjA5NkwzLjY4NzY3IDEwLjYwOTZDMy44NzAyOCAxMC40NjM1IDQuMTI5NzYgMTAuNDYzNSA0LjMxMjM3IDEwLjYwOTZMNi44MTIzNyAxMi42MDk2QzcuMDI4IDEyLjc4MjEgNy4wNjI5NiAxMy4wOTY3IDYuODkwNDUgMTMuMzEyM0M2LjcxNzk1IDEzLjUyOCA2LjQwMzMgMTMuNTYyOSA2LjE4NzY3IDEzLjM5MDRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";